import React from 'react';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigImageColumn} from '@src/@interfaces/components/List/IListConfigImageColumn';
import trans from '@src/helpers/trans';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {IFileModel} from '@src/@interfaces/models/FIle/IFileModel';
import app from '@src/helpers/app';

export default class ImageColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn<IListConfigImageColumn>, Model> {
    get value() {
        const field = (this.config.valueFrom ?? this.config.name) as keyof Model;
        const model = this.model;

        const availableNames = [`${String(field)}_public_path`, field];
        for (let i = 0; i < availableNames.length; i++) {
            const name = availableNames[i] as keyof Model;
            if (name in model) {
                return model[name];
            }
        }

        return null;
    }

    render() {
        const src = this.value as string | string[] | IFileModel[] | null;
        const sources = src == null ? [] : (
                Array.isArray(src) ? src : [src]
        ).map(item => typeof item === 'string' ? item : item.asset_file_path);
        if (!sources.length) {
            return this.renderEmptyColumn();
        }

        const config = this.config;
        const style: React.CSSProperties = {};

        if (config.width) {
            style.maxWidth = config.width + 'px';
        }

        if (config.height) {
            style.maxHeight = config.height + 'px';
        }

        // TODO: implement and include images cropper

        return <div className="models-list__content-table__image-preview-cell">
            {sources.map((src, i) => {
                return <img
                        key={i}
                        src={src}
                        alt={trans(this.listConfig.columnsNameL10NPrefix + (config.label ?? config.name))}
                        style={style}
                        className="models-list__content-table__image-preview"
                        onClick={e => {
                            e.stopPropagation();
                            e.preventDefault();

                            app('files-viewer').open(sources);
                        }}
                />;
            })}
        </div>;
    }
}
